import type { BeneficialOwner, ForeignBeneficialOwner } from "../types";

export const getBoName = (
	beneficialOwners: Array<BeneficialOwner>,
	foreignBeneficialOwners: Array<ForeignBeneficialOwner>,
	id: string,
) => {
	const { firstName = "", lastName = "" } =
		[...beneficialOwners, ...foreignBeneficialOwners]
			.map((b) => ({
				firstName: b.firstName,
				lastName: b.lastName,
				id: b.beneficialOwnerQuestionKey,
			}))
			.find((b) => b.id === id) || {};
	return `${firstName} ${lastName}`;
};
